import {groupRights} from "@services/current-rights.service";
import {Rights} from "@models/sportexam/rights";

export const blocks = [
    {
        id: 1, title: 'Испытания', class: 'tests', items: [
            {id: 1, icon: '/assets/icons/sportsmen.svg', name: 'Спортсмены', link:'athlets', right: groupRights.Sportsmen},
            {id: 2, icon: '/assets/icons/test-reports.svg', name: 'Протоколы', link:'protocols', right: groupRights.Protocols},
            {id: 3, icon: '/assets/icons/default/result.svg', name: 'Результаты', link:'results', right: true},
            {id: 4, icon: '/assets/icons/statistics.svg', name: 'Статистика', link:'statistics', right: groupRights.Protocols},
            {id: 5, icon: '/assets/icons/guides-indicators.svg', name: 'Упражнения', link:'types-of-examination', right: groupRights.Exercises},
        ]
    },
    {
        id: 2, title: 'Справочники', class: 'guides', items: [
            {id: 1, icon: '/assets/icons/default/guides-sports.svg', name: 'Виды спорта', link:'sports', right: groupRights.Sports},
            // {id: 2, icon: '/assets/icons/default/guides-tools.svg', name: 'Оборудование', link:'equipments'},
            // {id: 3, icon: '/assets/icons/default/guides-settings.svg', name: 'Типы испытаний', link:'checkup-protocols'},
            {id: 4, icon: '/assets/icons/default/guides-groups.svg', name: 'Категории упражнений', link:'exercise-category', right: groupRights.Exercises},
            {id: 5, icon: '/assets/icons/default/guides-types.svg', name: 'Типы результата', link:'measures', right: groupRights.Measures},
            {id: 6, icon: '/assets/icons/default/balance.svg', name: 'Единицы измерений', link:'measureunits', right: groupRights.MeasureUnits},
            {id: 7, icon: '/assets/icons/default/guides-organization.svg', name: 'Организации', link:'organization', right: groupRights.Organizations},
            {id: 9, icon: '/assets/icons/default/collections_bookmark-black.svg', name: 'Этапы подготовки', link:'traininggroups', right: groupRights.TrainingGroups},
            {id: 10, icon: '/assets/icons/default/normative.svg', name: 'Нормативы', link:'normatives', right: groupRights.Normatives},
            {id: 2, icon: '/assets/icons/coach.svg', name: 'Тренеры', link:'coaches', right: groupRights.Sportsmen},
        ]
    },
    {
        id: 3, title: 'Аналитика', class: 'analytics', items: [
            {id: 1, icon: '/assets/icons/default/analytics.svg', name: 'Протоколы', link:'analytics-protocols', right: 'watch_analytics_protocols' as keyof Rights},
            {id: 3, icon: '/assets/icons/default/normative.svg', name: 'Нормативы', link:'analytics-normatives', right: 'watch_analytics_normatives' as keyof Rights},
        ]
    },
    {
        id: 4, title: 'Администрирование', class: 'admin', items: [
            {id: 1, icon: '/assets/icons/default/guides-users.svg', name: 'Пользователи  ', link:'users', right: groupRights.Users},
        ]
    },

]
